import React from 'react'
import Toast from './Toast'

export enum ToastTypes {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}

export type ToastType = 'info' | 'warning' | 'error' | 'success'

export function Wrap(type: ToastTypes) {
  return function({ children, ...props }) {
    return (
      <Toast {...props} type={type}>
        {children}
      </Toast>
    )
  }
}

export default {
  Error: Wrap(ToastTypes.Error),
  Info: Wrap(ToastTypes.Info),
  Success: Wrap(ToastTypes.Success),
  Warning: Wrap(ToastTypes.Warning),
}
